/* Litborne variant selector — handles both 1-level and 2-level UI from JSON */
(function(){
  function esc(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function init(){
    var host = document.getElementById('lb-variant-host');
    var dataEl = document.getElementById('lb-vmap');
    if (!host || !dataEl || host.dataset.lbDone) return;
    var data; try { data = JSON.parse(dataEl.textContent); } catch(e) { return; }
    host.dataset.lbDone = '1';
    var idIn = document.getElementById('lb-vid');
    var opts = data.opts, vars = data.vars, cur = data.init.slice();

    function findVar(values){
      for (var i=0; i<vars.length; i++){
        var v = vars[i], ok = true;
        for (var j=0; j<values.length; j++){ if (v.vals[j] !== values[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }

    function applyCommon(v){
      if (!v) return;
      idIn.value = v.id;
      var pb = document.getElementById('lb-price-box');
      if (pb) {
        pb.innerHTML = v.ph
          ? '<span class="lb-info__price-sale lb-price-big" id="lb-price">' + esc(v.ph) + '</span><s class="lb-info__price-compare">' + esc(v.p) + '</s><span class="lb-s26-chip">&#10003; NOVEMBER26 APPLIED</span>'
          : '<span class="lb-info__price-sale" id="lb-price">' + esc(v.p) + '</span>';
      } else {
        var pe = document.getElementById('lb-price'); if (pe) pe.textContent = v.p;
      }
      var we = document.getElementById('lb-cta-was'); if (we) we.textContent = v.p;
      var te = document.getElementById('lb-cta-today');
      if (te && v.ph) te.textContent = v.ph;
      var btn = document.querySelector('.lb-buy');
      if (btn) { btn.disabled = !v.a; btn.textContent = v.a ? 'Add to Cart' : 'Sold Out'; }
    }

    if (opts.length === 1) {
      // Single-option UI (like old behavior)
      var html = '<p class="lb-var__label">' + esc(opts[0].name) + '</p><div class="lb-var__list" role="radiogroup">';
      vars.forEach(function(v){
        var sel = (v.vals[0] === cur[0]) ? ' is-selected' : '';
        html += '<label class="lb-var__opt' + sel + '" data-val="' + esc(v.vals[0]) + '">';
        html += '<span style="display:flex;align-items:center;flex:1;"><span class="lb-var__radio"></span><span style="display:flex;flex-direction:column;">';
        html += '<span class="lb-var__name">' + esc(v.vals[0]) + '</span>';
        if (v.vals[0] === 'Top-Grain Leather') html += '<span class="lb-var__sub">Italian leather. Buttery-soft.</span>';
        html += '</span></span><span class="lb-var__price">' + (v.ph ? esc(v.ph) + ' <s class="lb-var__was">' + esc(v.p) + '</s>' : esc(v.p)) + '</span></label>';
      });
      html += '</div>';
      host.innerHTML = html;
      var labels = host.querySelectorAll('.lb-var__opt');
      labels.forEach(function(lb){
        lb.addEventListener('click', function(){
          labels.forEach(function(x){ x.classList.remove('is-selected'); });
          lb.classList.add('is-selected');
          cur[0] = lb.getAttribute('data-val');
          applyCommon(findVar(cur));
        });
      });
      applyCommon(findVar(cur));
    } else {
      // Two-option UI: Size pills + Material rows
      // Assume opts[0]=Size, opts[1]=Material
      var sizeOpt = opts[0], matOpt = opts[1];
      var html = '<p class="lb-var__label">' + esc(sizeOpt.name) + '</p><div class="lb-size-row" role="radiogroup">';
      sizeOpt.values.forEach(function(s){
        var sel = (s === cur[0]) ? ' is-selected' : '';
        html += '<button type="button" class="lb-size-pill' + sel + '" data-val="' + esc(s) + '">' + esc(s) + '</button>';
      });
      html += '</div>';
      html += '<p class="lb-var__label" style="margin-top:22px;">' + esc(matOpt.name) + '</p><div class="lb-var__list" role="radiogroup">';
      matOpt.values.forEach(function(m){
        var sel = (m === cur[1]) ? ' is-selected' : '';
        html += '<label class="lb-mat-opt' + sel + '" data-val="' + esc(m) + '">';
        html += '<span style="display:flex;align-items:center;flex:1;"><span class="lb-var__radio"></span><span style="display:flex;flex-direction:column;">';
        html += '<span class="lb-var__name">' + esc(m) + '</span>';
        if (m === 'Top-Grain Leather') html += '<span class="lb-var__sub">Italian leather. Buttery-soft.</span>';
        html += '</span></span><span class="lb-var__price" data-mat-price></span></label>';
      });
      html += '</div>';
      host.innerHTML = html;

      var sB = host.querySelectorAll('.lb-size-pill');
      var mL = host.querySelectorAll('.lb-mat-opt');

      function applyAll(){
        applyCommon(findVar(cur));
        mL.forEach(function(ml){
          var m = ml.getAttribute('data-val');
          var v = findVar([cur[0], m]);
          var p = ml.querySelector('[data-mat-price]');
          if (v && p) p.innerHTML = v.ph ? esc(v.ph) + ' <s class="lb-var__was">' + esc(v.p) + '</s>' : esc(v.p);
        });
      }

      sB.forEach(function(b){
        b.addEventListener('click', function(){
          sB.forEach(function(x){ x.classList.remove('is-selected'); });
          b.classList.add('is-selected');
          cur[0] = b.getAttribute('data-val');
          applyAll();
        });
      });
      mL.forEach(function(ml){
        ml.addEventListener('click', function(){
          mL.forEach(function(x){ x.classList.remove('is-selected'); });
          ml.classList.add('is-selected');
          cur[1] = ml.getAttribute('data-val');
          applyAll();
        });
      });
      applyAll();
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
